<template>
  <div :class="[{ bottommargin: showSkipQuestion }, 'api-search-autocomplete']">
    <input
      v-model="selectedDisplayText"
      type="text"
      :placeholder="placeholder"
      @input="searchOnType($event.target.value)"
      @click="searchOnType($event.target.value)"
      @keydown="keyFunctions($event.keyCode)"
    />
    <a
      v-if="showSkipQuestion"
      class="no-result-link"
      @click="noResultClick"
      v-html="skipQuestionLabel"
    />
    <div v-if="displaySearchResults && label !== null" class="autocomplete-items">
      <div
        v-for="(result, key) in searchResults"
        :id="'search-' + key"
        :key="key"
        class=""
        @click="selectItem(key)"
        v-html="result[label]"
      />
    </div>
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import axios from 'axios';

export default {
  name: 'ApiSearch',
  emits: ['update:modelValue', 'no-result-click'],
  props: {
    api: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    minSearchStringLength: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default() {
        return true;
      }
    },
    label: {
      type: String,
      default: null
    },
    autoSelect: {
      type: Boolean,
      default: false
    },
    skipQuestionLabel: {
      type: String,
      default() {
        return '';
      }
    },
    skipQuestionFieldText: {
      type: String,
      default() {
        return '';
      }
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      searchResults: [],
      currentFocus: -1,
      selected: null,
      selectedDisplayText: '',
      displaySearchResults: false
    };
  },
  computed: {
    invalidReturnObject() {
      return this.invalidReturnObject_internal(this.selectedDisplayText);
    },
    showSkipQuestion() {
      return this.skipQuestionLabel !== '';
    }
  },
  watch: {
    selectedDisplayText(val) {
      if (val === '') {
        this.$emit('update:modelValue', this.invalidReturnObject);
      }
    }
  },

  mounted() {
    if (this.modelValue === null) {
      return;
    }

    if (typeof this.modelValue === 'string') {
      this.selectedDisplayText = this.modelValue;
      return;
    }

    this.selectedDisplayText = this.modelValue[this.label];
  },
  methods: {
    invalidReturnObject_internal(text) {
      return {
        label: text,
        value: 'INVALID',
        isStudent: false,
        resultType: 1
      };
    },
    searchOnType(search) {
      this.currentFocus = -1;
      if (search.length < this.minSearchStringLength) {
        this.searchResults = [];
        this.$emit('update:modelValue', this.invalidReturnObject_internal(search));
        return false;
      }

      const url = this.api + search;
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      axios
        .get(url, config)
        .then((resp) => {
          this.searchResults = search.trim().length > 0 ? resp.data : [];
          this.displaySearchResults = true;
          const exactMatch = this.findExactMatch(search);
          let returnObject = this.invalidReturnObject;
          if (exactMatch !== null && this.autoSelect) {
            this.selected = exactMatch;
            this.selectedDisplayText = exactMatch[this.label];
            returnObject = exactMatch;
          }
          this.$emit('update:modelValue', returnObject);
        })
        .catch((err) => {
          Utility.logError(err, this);
        })
        .finally(() => {});
    },
    keyFunctions(e) {
      if (e === 40) {
        // DOWN key is pressed
        this.incrementFocus();
        this.addActive(this.currentFocus);
      } else if (e === 38) {
        // UP key is pressed
        this.decrementFocus();
        this.addActive(this.currentFocus);
      } else if (e === 13) {
        // ENTER key is pressed
        if (this.currentFocus > -1) {
          this.selectItem(this.currentFocus);
        }
      }
    },
    addActive(x) {
      const autocompleteElmList = this.$el.querySelectorAll('.autocomplete-items div');
      this.removeActive(autocompleteElmList);
      autocompleteElmList[x].classList.add('autocomplete-active');
      autocompleteElmList[x].scrollIntoView();
    },
    removeActive(elmList) {
      for (var i = 0; i < elmList.length; i++) {
        elmList[i].classList.remove('autocomplete-active');
      }
    },
    selectItem(x) {
      this.selected = this.searchResults[x];
      this.selectedDisplayText = this.searchResults[x][this.label];
      this.$emit('update:modelValue', this.selected);
      this.displaySearchResults = false;
    },
    incrementFocus() {
      this.currentFocus =
        this.currentFocus >= this.searchResults.length - 1 ? 0 : (this.currentFocus += 1);
    },
    decrementFocus() {
      this.currentFocus =
        this.currentFocus <= 0 ? this.searchResults.length - 1 : (this.currentFocus -= 1);
    },
    clearResults() {
      // timeout hack to listen for click before blur
      setTimeout(() => {
        this.displaySearchResults = false;
      }, 200);
    },
    findExactMatch(search) {
      const searchMatch = this.searchResults.find(
        (element) => element[this.label].toLowerCase() === search.toLowerCase()
      );
      return typeof searchMatch === 'undefined' ? null : searchMatch;
    },
    noResultClick() {
      this.selectedDisplayText = this.skipQuestionFieldText;
      this.$emit('update:modelValue', this.invalidReturnObject);
      this.$parent.$parent.$emit('no-result-click');
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.no-result-link {
  position: absolute;
  bottom: rem-calc(-40px);
  right: rem-calc(5px);
}

.bottommargin {
  margin-bottom: rem-calc(5px);
}
</style>
